export enum UrlOrign {
    Domain = 0,
    Auth = 1,
}